module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    attrs: {
      "id": "inscripcio-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message')) + " "), _c('span', [_c('a', {
    attrs: {
      "href": _vm.$t('messageLink'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('messageLinkText')))])])]), _vm._v(" "), _c('div', {
    staticClass: "privacy-policies"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ffd6afa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home-geolocal/components/inscripcio-modal/inscripcio-modal.vue
// module id = 294
// module chunks = 0